import { ApolloError } from "@apollo/client"
import GetEnvironment from "../environments"

export const exceptionFromApolloError = (apolloError: ApolloError) => {
  console.log("Converting error!")
  console.log("Error: ")
  console.log(JSON.stringify(apolloError))
  console.log("Network Error: ")
  console.log(JSON.stringify(apolloError.networkError))

  // 1. Handle NETWORK-LEVEL errors (GraphQL server not reached)
  if (apolloError.networkError) {
    const networkError = apolloError.networkError as any
    // HTTP status from server, but GraphQL never executed
    if (networkError.statusCode) {
      return new Error(
        `Network Error when calling GraphQL. ` +
          `Status Code: ${networkError.statusCode}, ` +
          `Description: ${networkError.bodyText}`
      )
    }

    // Browser-level network error (CORS, DNS, server down, unreachable)
    return new Error(
      `GraphQL is unreachable through the network. ` +
        `Check the URL in the browser to troubleshoot (${GetEnvironment().quadriGraphQlUrl})`
    )
  }

  // 2. Handle GRAPHQL errors returned by the backend (server DID respond)
  const gqlError = apolloError.graphQLErrors?.[0]
  const message = gqlError?.message ?? "Unknown GraphQL error"
  const requestId = gqlError?.extensions?.requestId ?? "unknown"

  return new Error(
    `Exception in GraphQL when processing the request. Message: ${message}. RequestId: ${requestId}. See network trace for more info.`
  )
}
